import { useMutation } from "@tanstack/react-query";
import {
  getApiUrl,
  getInvoicesSettlementInvoicesBySettlementSettlementIDPath,
} from "Infrastructure/Api/Api";
import { JWT_KEY } from "Utils/AuthUtils";
import { getLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";
import FileSaver from "file-saver";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Settlements.SettlementList;

type Params = {
  settlementID: number;
};

const fetchSettlementInvoice = async ({ settlementID }: Params) => {
  const route = `${getApiUrl()}${getInvoicesSettlementInvoicesBySettlementSettlementIDPath(settlementID)}`;
  const response = await fetch(route, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: getLocalStorageItem(JWT_KEY) ?? "" },
  });

  return response;
};

export const useDownloadSettlementInvoiceMutation = () => {
  const { t } = useResource();

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await fetchSettlementInvoice(params);
      if (!response.ok) {
        throw new Error(t(COMPONENT_RESOURCES.DownloadInvoiceError));
      }
      const blob = await response.blob();
      const fileName = `${t(COMPONENT_RESOURCES.InvoiceFilePrefix)}${params.settlementID}.pdf`;
      FileSaver.saveAs(blob, fileName);
    },
    onError: () => {
      toast.error(t(COMPONENT_RESOURCES.DownloadInvoiceError));
    },
  });
};
